export default function () {
  const widgetName = 'dynamicBannerFeature';
  const widgetOpts = dynamicBannerFeatureOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    cardWidgetLoaded: function (data) {

      function customizeWidget() {

        $(`#${widgetName} .card-widget-item`).each(function () {



          // =======================================





          // Canada/eastern current time
          const timeZone = 'Canada/Eastern';
          const now = new Date().toLocaleString('en-US', { timeZone });

          // Banner days
          const dayOfWeek = new Date(now).getDay();
          // if (dayOfWeek >= 1 && dayOfWeek <= 5) { // Condition for work days

            // Banner hours TOKENS/////////
            let varTitle = $(this).find('.card-widget-title').text().split('|')
            let startTime = varTitle[0].split('{')[1] + ":00";
            let endTime = varTitle[1].split('}')[0] + ":00";

            if (startTime.length < 5) {
              startTime = "0" + startTime
            }

            if (endTime.length < 5) {
              endTime = "0" + endTime
            }


            $(this).find('.card-widget-title').remove()
            /////////
            const currentTime = new Date(now).toLocaleTimeString('en-US', { hour12: false });

            // append banner or not
            if (currentTime >= startTime && currentTime <= endTime) {
              // console.log("Current time ok " + startTime + " and " + endTime);
              $('.generalmessage').text('')
              $(this).appendTo('.generalmessage')
            }
            else {
              // console.log('closed');
              $(this).remove()
            }
          // }
          // else {
          //   // console.log('not work day');
          //   $(this).remove()
          // }

        })
      }
      customizeWidget()

    },
    buyNowButton: {
      visible: false,
      text: 'BUY NOW!'
    },
    DateRange: true,
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [''], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 3,
    moreButton: {
      visible: false,
      text: 'More'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: true
  });
}